<template>
  <section class="rounded-lg border bg-card p-6">
    <h3 class="text-base font-medium">
      Template Variables
    </h3>
    <p class="mt-2 text-sm text-muted-foreground">
      Variables are detected from the template title and description. Launching the template will ask for these values.
    </p>

    <div v-if="variablesSchema.length === 0" class="mt-4 rounded-md border border-dashed px-4 py-3 text-sm text-muted-foreground">
      No variables detected yet. Use tokens like <span class="font-mono text-foreground">[[customer_name]]</span> in the title or description.
    </div>

    <div v-else class="mt-4 flex flex-col gap-3">
      <div
        v-for="schemaEntry in variablesSchema"
        :key="schemaEntry.key"
        class="rounded-md border px-4 py-3"
      >
        <div class="flex flex-wrap items-center gap-2">
          <span class="font-medium text-foreground">{{ schemaEntry.label }}</span>
          <span class="rounded-full border px-2 py-0.5 text-xs text-muted-foreground">{{ schemaEntry.type }}</span>
          <span class="rounded-full border px-2 py-0.5 text-xs text-muted-foreground">
            {{ schemaEntry.required ? 'Required' : 'Optional' }}
          </span>
        </div>

        <p class="mt-2 font-mono text-sm text-foreground">
          [[{{ schemaEntry.key }}]]
        </p>

        <p v-if="schemaEntry.sourcesLabel" class="mt-2 text-sm text-muted-foreground">
          Used in: {{ schemaEntry.sourcesLabel }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { formatTaskTemplateVariableSources } from '../../utils/taskTemplateVariables.js'

const props = defineProps({
  taskTemplate: {
    type: Object,
    required: true,
  },
})

const variablesSchema = computed(() => {
  return (Array.isArray(props.taskTemplate?.variables_schema) ? props.taskTemplate.variables_schema : [])
    .filter((schemaEntry) => typeof schemaEntry?.key === 'string' && schemaEntry.key.trim() !== '')
    .map((schemaEntry) => ({
      ...schemaEntry,
      label: typeof schemaEntry.label === 'string' && schemaEntry.label.trim() !== ''
        ? schemaEntry.label
        : schemaEntry.key,
      type: typeof schemaEntry.type === 'string' && schemaEntry.type.trim() !== ''
        ? schemaEntry.type
        : 'text',
      required: schemaEntry.required === true,
      sourcesLabel: formatTaskTemplateVariableSources(schemaEntry.sources),
    }))
})
</script>
